import React from 'react'
import PropTypes from 'prop-types'

import { AutocompleteTypeAndSearch } from 'components'

import useAuth from 'hooks/useAuth'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'

const MIN_CHARS_TO_SEARCH = 2
const SEARCH_PER_PAGE = 20

const PartnerForm = ({ errors, preAvaliation, label = 'Fornecedor' }) => {
  const { company } = useAuth()
  const snackbar = useSnackbar()

  // O componente não trata erro: sem o catch o loading fica preso.
  const loadPartners = async (term) => {
    try {
      const response = await service.dponet.companies.searchSupplierReport({
        companyId: company.id,
        term,
        preAvaliation,
        perPage: SEARCH_PER_PAGE,
      })

      return (response?.data?.companySuppliers || []).map((companySupplier) => {
        const { id, name, document } = companySupplier.supplier
        const displayName =
          companySupplier.displayName || name || '[Razão Social não informada]'

        return {
          id,
          companySupplierId: companySupplier.id,
          name: `${displayName} - ${document}`,
        }
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(
            error?.response?.data?.error,
            false,
          ) || 'Falha ao buscar fornecedores.',
        variant: 'error',
      })
      return []
    }
  }

  return (
    <AutocompleteTypeAndSearch
      name="partnerId"
      minCharsToSearch={MIN_CHARS_TO_SEARCH}
      requestToLoadOptions={loadPartners}
      filterOptions={(options) => options}
      textField={{
        label,
        variant: 'outlined',
        fullWidth: true,
        error: !!errors?.partnerId,
        helperText: errors?.partnerId?.message,
      }}
    />
  )
}

PartnerForm.propTypes = {
  errors: PropTypes.object,
  preAvaliation: PropTypes.bool,
  label: PropTypes.string,
}

export default PartnerForm
